module.exports = __webpack_public_path__ + "static/media/download.868681ca.svg";